import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TelecallerInputBar from "../../components/Telecallers/TelecallerInputBar";
import TelecallerLeadsList from "../../components/TelecallerLeads/TelecallerLeadsList";
import TeleLeadsFormModal from "../../components/TelecallerLeads/TeleLeadsFormModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TelecallerActions from "../../store/actions/Telecaller";
import * as TelecallerLeadsActions from "../../store/actions/TelecallerLeads";
import ListPagination from "../../components/Common/ListPagination";
import { getPath, isMobile, debounce } from "../../utils";
import {
  FlexContainer,
  Heading,
  ViewContainer,
} from "../../constants/assets/containers";
import FilterButton from "../../components/Common/FilterButton";
import TeleLeadsFilterFormModal from "../../components/TelecallerLeads/TeleLeadsFilterFormModal";

const TelecallerLeads = (props) => {
  const {
    telecallerProfiles,
    getTelecallerProfiles,
    getReasons,
    rejectionReasons,
    resetState,
    getTelecallerLeads,
    telecallerLeads,
    setActiveLeadEngagement,
    callStatuses,
  } = props;
  const [activeTelecaller, setActiveTelecaller] = useState("");
  const [activeLead, setActiveLead] = useState("");
  const [modalState, setModalState] = useState(false);
  const [filterModalState, setFilterModalState] = useState(false);
  const [filterButtonState, setFilterButtonState] = useState(false);
  const [telecallers, setTelecallers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const handleSubmit = (val) => {
    if (val) {
      getTelecallerLeads(val);
      setActiveTelecaller(val);
      setFilterButtonState(true);
    } else {
      setFilterButtonState(false);
    }
  };

  // handle pagination
  const handleNavClick = debounce((action) => {
    if (action === "prev") {
      if (currentPage === 1) {
        return;
      }
      const pageNo = Math.max(currentPage - 1, 1);
      const pageRequest = {
        page_number: pageNo,
      };
      setCurrentPage(pageNo);
      if (Object.keys(props.telecallerActiveFilter).length > 0) {
        props.getLeadFilterEngagement(
          props.telecallerActiveFilter,
          pageRequest,
          activeTelecaller
        );
      } else {
        getTelecallerLeads(activeTelecaller, pageRequest);
      }
    } else {
      const pageRequest = {
        page_number: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      if (Object.keys(props.telecallerActiveFilter).length > 0) {
        props.getLeadFilterEngagement(
          props.telecallerActiveFilter,
          pageRequest,
          activeTelecaller
        );
      } else {
        getTelecallerLeads(activeTelecaller, pageRequest);
      }
    }
  }, 500);

  const handleModalClose = () => {
    setModalState(false);
    setFilterModalState(false);
  };

  const handleViewClick = (payload) => {
    setActiveLeadEngagement(payload);
    setActiveLead(payload.id);
    setModalState(true);
  };

  useEffect(() => {
    getTelecallerProfiles().then((res) => {
      const telecallersInLMS = getPath(res, "telecallers", []).filter(
        (item) => item.present_in_lms === true
      );
      setTelecallers(telecallersInLMS);
    });
    resetState({ state: "telecallerLeads" });
    if (rejectionReasons.length === 0) {
      getReasons();
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.telecallerActiveFilter)]);

  const handleFilterButtonClick = () => {
    setFilterModalState(true);
  };

  return (
    <TelecallerLeadsView>
      <FlexContainer className="leads-holder mb-20">
        <Heading>Telecaller Leads</Heading>
        <div className="right-container flex items-center">
          <TelecallerInputBar
            handleSubmitClick={handleSubmit}
            telecallerList={telecallers}
          />
          {filterButtonState && (
            <FilterButton
              handleClick={handleFilterButtonClick}
              activeFilters={{}}
            />
          )}
        </div>
      </FlexContainer>

      <TelecallerLeadsList
        callStatuses={callStatuses}
        list={telecallerLeads}
        handleViewClick={handleViewClick}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <TeleLeadsFormModal
          rejectionReasons={rejectionReasons}
          activeLead={activeLead}
          activeTelecaller={activeTelecaller}
          modalState={modalState}
          handleClose={handleModalClose}
        />
      )}
      {filterModalState && (
        <TeleLeadsFilterFormModal
          handleClose={handleModalClose}
          activeTelecaller={activeTelecaller}
        />
      )}
    </TelecallerLeadsView>
  );
};

const TelecallerLeadsView = styled(ViewContainer)`
  .table-container {
    height: calc(100% - 120px);
  }
  .leads-holder {
    flex-direction: ${isMobile() ? "column" : "row"};
    align-items: ${isMobile() ? "flex-start" : "center"};
  }
  .sushi-btn {
    margin-top: ${isMobile() ? "10px" : "unset"};
  }
  & > div:first-child > div {
    max-width: 100%;
    margin-top: ${isMobile() ? "10px" : "unset"};
    flex-direction: ${isMobile() ? "column" : "row"};
    align-items: ${isMobile() ? "flex-start" : "center"};
    .right-container {
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
    & > div {
      margin-bottom: unset;
    }
  }
  .customDropdown {
    min-width: 300px;
  }
  & > div > button {
    margin-left: 20px;
  }
`;

const mapStateToProps = (state) => {
  const { Telecaller, TelecallerLeads } = state;
  return {
    telecallerProfiles: Telecaller.telecallerProfiles,
    telecallerLeads: TelecallerLeads.telecallerLeads,
    nextPage: TelecallerLeads.nextPage,
    prevPage: TelecallerLeads.prevPage,
    rejectionReasons: TelecallerLeads.rejectionReasons,
    callStatuses: TelecallerLeads.callStatuses,
    telecallerActiveFilter: TelecallerLeads.activeFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTelecallerProfiles: bindActionCreators(
      TelecallerActions.getTelecallerProfiles,
      dispatch
    ),
    getTelecallerLeads: bindActionCreators(
      TelecallerLeadsActions.getTelecallerLeads,
      dispatch
    ),
    getReasons: bindActionCreators(TelecallerLeadsActions.getReasons, dispatch),
    resetState: bindActionCreators(TelecallerLeadsActions.resetState, dispatch),
    setActiveLeadEngagement: bindActionCreators(
      TelecallerLeadsActions.setActiveLeadEngagement,
      dispatch
    ),
    getLeadFilterEngagement: bindActionCreators(
      TelecallerLeadsActions.filterLeadEngagement,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TelecallerLeads);
